import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsUiModule } from '@nuso/forms/ui';
import { IamDialogService } from './iam-dialog.service';

export { IamDialogService };

@NgModule({
  imports:
  [
    CommonModule,
    FormsUiModule,
  ],
  providers: [IamDialogService]
})
export class IamDataAccessModule {}
